export default "__VITE_ASSET__Cqg7_nKo__"